var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-side-navigation" }, [
    _c(
      "div",
      { staticClass: "is-sticky" },
      _vm._l(_vm.navigation, function (ref, index) {
        var title = ref.title
        var menu = ref.menu
        return _c(
          "div",
          { key: index, staticClass: "nav-section" },
          [
            title
              ? _c("h5", { staticClass: "nav-section__title" }, [
                  _vm._v(_vm._s(title)),
                ])
              : _vm._e(),
            _vm._t("default"),
            _c(
              "ul",
              _vm._l(menu, function (ref) {
                var name = ref.name
                var id = ref.id
                var link = ref.link
                return _c(
                  "li",
                  { key: id },
                  [
                    _c(
                      "router-link",
                      { staticClass: "nav-section__link", attrs: { to: link } },
                      [_vm._v(_vm._s(name))]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }